// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { CreateChatData, CreateChatErrors, CreateChatResponses, DeleteMessageData, DeleteMessageErrors, DeleteMessageReactionData, DeleteMessageReactionErrors, DeleteMessageReactionResponses, DeleteMessageResponses, DeletePushSubscriptionData, DeletePushSubscriptionErrors, DeletePushSubscriptionResponses, GetChatByGroupSlugData, GetChatByGroupSlugErrors, GetChatByGroupSlugResponses, GetChatByUserSlugData, GetChatByUserSlugErrors, GetChatByUserSlugResponses, GetChatData, GetChatErrors, GetChatNotificationSettingsData, GetChatNotificationSettingsErrors, GetChatNotificationSettingsResponses, GetChatResponses, GetLatestMessagesData, GetLatestMessagesErrors, GetLatestMessagesResponses, GetMessageContextData, GetMessageContextErrors, GetMessageContextResponses, GetMessageReactionsData, GetMessageReactionsErrors, GetMessageReactionsResponses, GetMessagesData, GetMessagesErrors, GetMessagesResponses, GetUnreadMessageCountData, GetUnreadMessageCountErrors, GetUnreadMessageCountResponses, GetUserNotificationSettingsData, GetUserNotificationSettingsErrors, GetUserNotificationSettingsResponses, HealthData, HealthErrors, HealthResponses, ListChatsData, ListChatsErrors, ListChatsResponses, MarkMessageReadData, MarkMessageReadErrors, MarkMessageReadResponses, PutMessageReactionData, PutMessageReactionErrors, PutMessageReactionResponses, RegisterPushSubscriptionData, RegisterPushSubscriptionErrors, RegisterPushSubscriptionResponses, SearchMessagesData, SearchMessagesErrors, SearchMessagesResponses, SendMessageData, SendMessageErrors, SendMessageResponses, SendMessageWithAttachmentsData, SendMessageWithAttachmentsErrors, SendMessageWithAttachmentsResponses, UpdateChatNotificationSettingsData, UpdateChatNotificationSettingsErrors, UpdateChatNotificationSettingsResponses, UpdateMessageData, UpdateMessageErrors, UpdateMessageResponses, UpdateUserNotificationSettingsData, UpdateUserNotificationSettingsErrors, UpdateUserNotificationSettingsResponses, UploadMessageAttachmentData, UploadMessageAttachmentErrors, UploadMessageAttachmentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class ChatService {
    /**
     * Групповой чат по slug
     */
    public static getChatByGroupSlug<ThrowOnError extends boolean = false>(options: Options<GetChatByGroupSlugData, ThrowOnError>): RequestResult<GetChatByGroupSlugResponses, GetChatByGroupSlugErrors, ThrowOnError> {
        return (options.client ?? client).get<GetChatByGroupSlugResponses, GetChatByGroupSlugErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chat-slugs/groups/{slug}',
            ...options
        });
    }
    
    /**
     * Личный чат по username
     */
    public static getChatByUserSlug<ThrowOnError extends boolean = false>(options: Options<GetChatByUserSlugData, ThrowOnError>): RequestResult<GetChatByUserSlugResponses, GetChatByUserSlugErrors, ThrowOnError> {
        return (options.client ?? client).get<GetChatByUserSlugResponses, GetChatByUserSlugErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chat-slugs/users/{username}',
            ...options
        });
    }
    
    /**
     * Список чатов
     */
    public static listChats<ThrowOnError extends boolean = false>(options?: Options<ListChatsData, ThrowOnError>): RequestResult<ListChatsResponses, ListChatsErrors, ThrowOnError> {
        return (options?.client ?? client).get<ListChatsResponses, ListChatsErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats',
            ...options
        });
    }
    
    /**
     * Создание чата
     */
    public static createChat<ThrowOnError extends boolean = false>(options: Options<CreateChatData, ThrowOnError>): RequestResult<CreateChatResponses, CreateChatErrors, ThrowOnError> {
        return (options.client ?? client).post<CreateChatResponses, CreateChatErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Информация о чате
     */
    public static getChat<ThrowOnError extends boolean = false>(options: Options<GetChatData, ThrowOnError>): RequestResult<GetChatResponses, GetChatErrors, ThrowOnError> {
        return (options.client ?? client).get<GetChatResponses, GetChatErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}',
            ...options
        });
    }
}

export class MessageService {
    /**
     * История сообщений
     */
    public static getMessages<ThrowOnError extends boolean = false>(options: Options<GetMessagesData, ThrowOnError>): RequestResult<GetMessagesResponses, GetMessagesErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMessagesResponses, GetMessagesErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages',
            ...options
        });
    }
    
    /**
     * Отправка сообщения
     */
    public static sendMessage<ThrowOnError extends boolean = false>(options: Options<SendMessageData, ThrowOnError>): RequestResult<SendMessageResponses, SendMessageErrors, ThrowOnError> {
        return (options.client ?? client).post<SendMessageResponses, SendMessageErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Загрузка вложения сообщения
     */
    public static uploadMessageAttachment<ThrowOnError extends boolean = false>(options: Options<UploadMessageAttachmentData, ThrowOnError>): RequestResult<UploadMessageAttachmentResponses, UploadMessageAttachmentErrors, ThrowOnError> {
        return (options.client ?? client).post<UploadMessageAttachmentResponses, UploadMessageAttachmentErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/attachments',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Последние сообщения чата
     */
    public static getLatestMessages<ThrowOnError extends boolean = false>(options: Options<GetLatestMessagesData, ThrowOnError>): RequestResult<GetLatestMessagesResponses, GetLatestMessagesErrors, ThrowOnError> {
        return (options.client ?? client).get<GetLatestMessagesResponses, GetLatestMessagesErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/latest',
            ...options
        });
    }
    
    /**
     * Поиск сообщений
     */
    public static searchMessages<ThrowOnError extends boolean = false>(options: Options<SearchMessagesData, ThrowOnError>): RequestResult<SearchMessagesResponses, SearchMessagesErrors, ThrowOnError> {
        return (options.client ?? client).get<SearchMessagesResponses, SearchMessagesErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/search',
            ...options
        });
    }
    
    /**
     * Отправка сообщения с вложениями
     */
    public static sendMessageWithAttachments<ThrowOnError extends boolean = false>(options: Options<SendMessageWithAttachmentsData, ThrowOnError>): RequestResult<SendMessageWithAttachmentsResponses, SendMessageWithAttachmentsErrors, ThrowOnError> {
        return (options.client ?? client).post<SendMessageWithAttachmentsResponses, SendMessageWithAttachmentsErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/with-attachments',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Удаление сообщения
     */
    public static deleteMessage<ThrowOnError extends boolean = false>(options: Options<DeleteMessageData, ThrowOnError>): RequestResult<DeleteMessageResponses, DeleteMessageErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMessageResponses, DeleteMessageErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/{messageId}',
            ...options
        });
    }
    
    /**
     * Изменение сообщения
     */
    public static updateMessage<ThrowOnError extends boolean = false>(options: Options<UpdateMessageData, ThrowOnError>): RequestResult<UpdateMessageResponses, UpdateMessageErrors, ThrowOnError> {
        return (options.client ?? client).patch<UpdateMessageResponses, UpdateMessageErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/{messageId}',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Контекст сообщения
     */
    public static getMessageContext<ThrowOnError extends boolean = false>(options: Options<GetMessageContextData, ThrowOnError>): RequestResult<GetMessageContextResponses, GetMessageContextErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMessageContextResponses, GetMessageContextErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/{messageId}/context',
            ...options
        });
    }
    
    /**
     * Снять реакцию
     */
    public static deleteMessageReaction<ThrowOnError extends boolean = false>(options: Options<DeleteMessageReactionData, ThrowOnError>): RequestResult<DeleteMessageReactionResponses, DeleteMessageReactionErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeleteMessageReactionResponses, DeleteMessageReactionErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/{messageId}/reaction',
            ...options
        });
    }
    
    /**
     * Поставить или заменить реакцию
     */
    public static putMessageReaction<ThrowOnError extends boolean = false>(options: Options<PutMessageReactionData, ThrowOnError>): RequestResult<PutMessageReactionResponses, PutMessageReactionErrors, ThrowOnError> {
        return (options.client ?? client).put<PutMessageReactionResponses, PutMessageReactionErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/{messageId}/reaction',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Подробности реакций
     */
    public static getMessageReactions<ThrowOnError extends boolean = false>(options: Options<GetMessageReactionsData, ThrowOnError>): RequestResult<GetMessageReactionsResponses, GetMessageReactionsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetMessageReactionsResponses, GetMessageReactionsErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/{messageId}/reactions',
            ...options
        });
    }
    
    /**
     * Отметить сообщение прочитанным
     */
    public static markMessageRead<ThrowOnError extends boolean = false>(options: Options<MarkMessageReadData, ThrowOnError>): RequestResult<MarkMessageReadResponses, MarkMessageReadErrors, ThrowOnError> {
        return (options.client ?? client).post<MarkMessageReadResponses, MarkMessageReadErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/messages/{messageId}/read',
            ...options
        });
    }
    
    /**
     * Общее число непрочитанных сообщений
     */
    public static getUnreadMessageCount<ThrowOnError extends boolean = false>(options?: Options<GetUnreadMessageCountData, ThrowOnError>): RequestResult<GetUnreadMessageCountResponses, GetUnreadMessageCountErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUnreadMessageCountResponses, GetUnreadMessageCountErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/messages/unread-count',
            ...options
        });
    }
}

export class NotificationService {
    /**
     * Настройки уведомлений в чате
     */
    public static getChatNotificationSettings<ThrowOnError extends boolean = false>(options: Options<GetChatNotificationSettingsData, ThrowOnError>): RequestResult<GetChatNotificationSettingsResponses, GetChatNotificationSettingsErrors, ThrowOnError> {
        return (options.client ?? client).get<GetChatNotificationSettingsResponses, GetChatNotificationSettingsErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/notification-settings',
            ...options
        });
    }
    
    /**
     * Изменить настройки уведомлений в чате
     */
    public static updateChatNotificationSettings<ThrowOnError extends boolean = false>(options: Options<UpdateChatNotificationSettingsData, ThrowOnError>): RequestResult<UpdateChatNotificationSettingsResponses, UpdateChatNotificationSettingsErrors, ThrowOnError> {
        return (options.client ?? client).patch<UpdateChatNotificationSettingsResponses, UpdateChatNotificationSettingsErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/chats/{id}/notification-settings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Глобальные настройки уведомлений
     */
    public static getUserNotificationSettings<ThrowOnError extends boolean = false>(options?: Options<GetUserNotificationSettingsData, ThrowOnError>): RequestResult<GetUserNotificationSettingsResponses, GetUserNotificationSettingsErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetUserNotificationSettingsResponses, GetUserNotificationSettingsErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/notification-settings',
            ...options
        });
    }
    
    /**
     * Изменить глобальные настройки уведомлений
     */
    public static updateUserNotificationSettings<ThrowOnError extends boolean = false>(options: Options<UpdateUserNotificationSettingsData, ThrowOnError>): RequestResult<UpdateUserNotificationSettingsResponses, UpdateUserNotificationSettingsErrors, ThrowOnError> {
        return (options.client ?? client).patch<UpdateUserNotificationSettingsResponses, UpdateUserNotificationSettingsErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/notification-settings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Зарегистрировать Web Push-подписку
     */
    public static registerPushSubscription<ThrowOnError extends boolean = false>(options: Options<RegisterPushSubscriptionData, ThrowOnError>): RequestResult<RegisterPushSubscriptionResponses, RegisterPushSubscriptionErrors, ThrowOnError> {
        return (options.client ?? client).put<RegisterPushSubscriptionResponses, RegisterPushSubscriptionErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/push-subscriptions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Удалить Web Push-подписку
     */
    public static deletePushSubscription<ThrowOnError extends boolean = false>(options: Options<DeletePushSubscriptionData, ThrowOnError>): RequestResult<DeletePushSubscriptionResponses, DeletePushSubscriptionErrors, ThrowOnError> {
        return (options.client ?? client).delete<DeletePushSubscriptionResponses, DeletePushSubscriptionErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/push-subscriptions/{subscriptionId}',
            ...options
        });
    }
}

export class InternalService {
    /**
     * Health check
     *
     * Returns status 200 if service is alive and connections are healthy
     */
    public static health<ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>): RequestResult<HealthResponses, HealthErrors, ThrowOnError> {
        return (options?.client ?? client).get<HealthResponses, HealthErrors, ThrowOnError>({ url: '/health', ...options });
    }
}
